import { useNavigate } from 'react-router-dom'
import AppCard from 'ui/AppCard'

const FeedingPlanCard = () => {
	const navigate = useNavigate()

	return (
		<AppCard
			title='План кормления'
			description='Настройте расписание плана кормления по группам.'
			onClick={() => navigate('/feed/plan/edit')}
		/>
	)
}

export default FeedingPlanCard
